export default {
  "content": "<path d=\"M15.47 21H8.53v-2h6.94v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a2 2 0 012 2v9a2 2 0 01-2 2h-15a2 2 0 01-2-2V6a2 2 0 012-2h15zm-15 11h15V6h-15v9z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};